import React from 'react';
import { Button } from './ui/button';
import { ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-4">
              <img 
                src="/assets/tribal-root-logo-white.png" 
                alt="TribalRoot.AI Logo" 
                className="h-10 w-auto mr-3"
                onError={(e) => {
                  // Fallback to text logo if image fails to load
                  e.target.style.display = 'none';
                  e.target.nextElementSibling.style.display = 'flex';
                }}
              />
              <div className="w-10 h-10 bg-amber-600 rounded-full items-center justify-center mr-3 hidden">
                <span className="text-white font-bold text-lg">TR</span>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              Empowering Indigenous peoples to reclaim their ancestral legacy through AI-powered genealogy and cultural restoration.
            </p>
            
            {/* Social Links removed per user request */}
          </div>

          {/* Platform */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Platform</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  AI Genealogy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Tribal Rights
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Crest Generator
                </a>
              </li>
              <li>
                <a href="/healing-grounds" className="text-gray-400 hover:text-white transition-colors">
                  Healing Remedies
                </a>
              </li>
            </ul>
          </div>

          {/* Resources section removed per user request */}
          <div></div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 TribalRoot.AI. All rights reserved.
          </p>
          
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={scrollToTop}
            className="text-gray-400 hover:text-white hover:bg-gray-800 transition-colors mt-4 md:mt-0"
          >
            <ArrowUp className="w-4 h-4 mr-2" />
            Scroll to Top
          </Button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;